<template>

<v-card >
<v-toolbar dense flat color="#273C51">
<v-toolbar-title style="color:white"  >Добавление нового сервера</v-toolbar-title>
<v-spacer/>
<v-icon color="white" @click="close()">mdi-close</v-icon>
</v-toolbar>
<v-card-text>
<v-text-field v-model="server.title" color="#273C51" hide-details style="margin-bottom:10px" label='Название сервера - например "мой сервер"'  box outline clearable />
<v-text-field v-model="server.server" color="#273C51" hide-details style="margin-bottom:10px" label="ip адресс сервера, по умолчанию localhost."   box outline clearable />
<v-text-field v-model="server.loginSql" color="#273C51" hide-details style="margin-bottom:10px" label="Пользователь баз данных."    box outline clearable />
<v-text-field v-model="server.paswordSql" color="#273C51" hide-details style="margin-bottom:10px"  label="Пароль баз данных."   box outline clearable />
<v-text-field v-model="server.serverSql" color="#273C51" hide-details style="margin-bottom:10px"  label="Ip баз данных."  box outline clearable />
</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn color="#273C51"  @click="close()" style="text-transform:none !important" flat small>Отменить</v-btn>
<v-btn color="#273C51" class="white--text" @click="saveServer()" style="text-transform:none !important" small> <v-icon>mdi-plus</v-icon> Добавить сервер</v-btn>
</v-card-actions>
</v-card>

</template>

<script>

export default {
  name: 'CreateServer',
  props:['modals','servers'],
  data: () => ({
    server:{
                      title:"",
                      server:"localhost",
                      status:1,
                      loginSql:"root",
                      paswordSql:"",
                      serverSql:"localhost",
            },
  }),
  methods:{
close(){
  this.modals.creator = false
},
saveServer(){ 
  if(localStorage.servers){
    let servers = JSON.parse(localStorage.servers)
    servers.push(this.server)
    localStorage.servers = JSON.stringify(servers)
  } else {
    let servers = []
    servers.push(this.server)
    localStorage.servers = JSON.stringify(servers)
    localStorage.server = JSON.stringify(this.server)
  }
  this.$router.go()

},
  }
};
</script>
